import _extends from "@babel/runtime-corejs3/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/esm/objectWithoutProperties";
var _excluded = ["label", "field", "form", "returnedDateFormat", "displayedDateFormat", "readOnly", "isOutsideRange"];
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js/instance/concat";
import { DatePickerDropdown } from "@xo-union/tk-component-datepicker";
import moment from "moment";
import React from "react";
import DateDropdownField from "./DateDropdownField.js";
import styles from "./dateDropdown.css";
export var DateDropdown = function DateDropdown(_ref) {
  var _context;
  var label = _ref.label,
    field = _ref.field,
    form = _ref.form,
    _ref$returnedDateForm = _ref.returnedDateFormat,
    returnedDateFormat = _ref$returnedDateForm === void 0 ? 'YYYY-MM-DD' : _ref$returnedDateForm,
    _ref$displayedDateFor = _ref.displayedDateFormat,
    displayedDateFormat = _ref$displayedDateFor === void 0 ? 'MMMM DD, YYYY' : _ref$displayedDateFor,
    _ref$readOnly = _ref.readOnly,
    readOnly = _ref$readOnly === void 0 ? true : _ref$readOnly,
    isOutsideRange = _ref.isOutsideRange,
    rest = _objectWithoutProperties(_ref, _excluded);
  var name = field.name,
    date = field.value;
  var setFieldValue = form.setFieldValue;
  var momentDate = moment.utc(date, returnedDateFormat, true);
  var onDateChange = function onDateChange(dt) {
    if (moment.isMoment(dt)) {
      var formattedDate = dt.format(returnedDateFormat);
      setFieldValue(name, formattedDate);
    } else {
      setFieldValue(name, dt);
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    className: _concatInstanceProperty(_context = "".concat(styles.container, " ")).call(_context, readOnly ? '' : styles.withPlaceHolder)
  }, /*#__PURE__*/React.createElement(DatePickerDropdown, {
    date: momentDate.isValid() ? momentDate : null,
    dateFormat: displayedDateFormat,
    onDateChange: onDateChange,
    isOutsideRange: isOutsideRange,
    renderInput: function renderInput(props) {
      return /*#__PURE__*/React.createElement(DateDropdownField, _extends({
        readOnly: readOnly,
        name: name || 'date',
        label: label || 'Date',
        onChange: onDateChange,
        form: form
      }, props, rest));
    }
  }));
};